import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore.ts'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { MachineEtat } from '@/features/domaine/machine-etats'
import { BatchesUpdateConfiguration } from '@/features/interface/demande/af/steps/frais/batchUpdate/BatchUpdateConfiguration.ts'
import type {
  BatchUpdateLaunch,
  BatchUpdateResult,
} from '@/features/interface/demande/af/steps/frais/batchUpdate/BatchUpdateType.ts'
import { isNotNullOrUndefined } from '@/features/shared/tools'

export const useBatchUpdate = () => {
  const store = useDemandeAFStore()
  const { setupCustomUpdater } = store

  const appliquerBatch = setupCustomUpdater<BatchUpdateResult>((patch, options) => {
    const fraisAnnexesAPatcher =
      patch.fraisAnnexes!.filter(fa => fa.moduleId === options.module.id)

    for (const fraisAnnexes of fraisAnnexesAPatcher) {
      const frais = fraisAnnexes.frais
        .find((f) => f.nature === options.natureFraisAnnexe.nature)!

      if (isNotNullOrUndefined(options.montant))
        frais.montant = options.montant
      if (options.natureFraisAnnexe.baseCalcul !== 'Quantite') continue
      if (isNotNullOrUndefined(options.quantite))
        frais.quantite = options.quantite
    }
  })

  async function showDialog(launchParams: BatchUpdateLaunch) {
    const engine = new MachineEtat(BatchesUpdateConfiguration)
    const result = await engine
      .launch({
        titre: 'Modifier les frais annexes en masse ',
        contextCourant: TypesContextesAutorisesEnum.Aucun,
        launchParams,
      })
    if (!result) return
    await appliquerBatch(result)
  }

  return {
    showDialog,
  }
}
